var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"cols":"10","md":"8"}},[_c('b-form-text',{attrs:{"text-variant":"secondary"}},[_c('h5',{staticStyle:{"text-align":"center"}},[_vm._t("default")],2)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }